import * as React from 'react';

export default function Info({...rest}) {
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.626 1 1 5.626 1 12C1 18.374 5.626 23 12 23C18.374 23 23 18.374 23 12C23 5.626 18.374 1 12 1ZM12 2.33C17.603 2.33 21.67 6.397 21.67 12C21.67 17.603 17.603 21.67 12 21.67C6.397 21.67 2.33 17.603 2.33 12C2.33 6.397 6.397 2.33 12 2.33ZM12 6.49301C12.442 6.49301 12.774 6.78801 12.774 7.30401C12.774 7.82001 12.442 8.11501 12 8.11501C11.558 8.11501 11.226 7.82001 11.226 7.30401C11.226 6.78801 11.558 6.49301 12 6.49301ZM12.783 15.656V10.007H9.41401V11.337H11.453V15.656H8.41901V16.986L15.386 16.985V15.655L12.783 15.656Z"
        fill="#001E50"
      />
    </svg>
  );
}
